import { graphql } from "react-relay";
import { AvatarPerson } from "@components/avatar";
import { SuggestionBodyAutopilot } from "./SuggestionBodyAutopilot";

// reusable fragment for flowstate on user and org
graphql`
  fragment SuggestionBodyAutopilot_eventTime on EventTime {
    type
    dateOrDateTime
    timeZone
    millis
    offsetMinutes
  }
`;

export const suggestionBodyAutopilotFragments = {
  org: graphql`
    fragment SuggestionBodyAutopilot_org on Org
    @argumentDefinitions(calendarIds: { type: "[String]!", defaultValue: [] }) {
      id
      personsByCalendarIdsErrorable(calendarIds: $calendarIds) {
        __typename
        ... on PersonList {
          list {
            __typename
            id
            emails
            primaryEmail
            isYou
            userId
            isUser
            profile {
              givenName
              familyName
              externalImageUrl
            }
          }
        }
        ... on GraphEntityError {
          message
        }
      }
    }
  `,
  suggestionPayload: graphql`
    fragment SuggestionBodyAutopilot_suggestionPayload on SuggestionResultPayload {
      ... on SuggestionResultMeetingNotOnAutopilotPayload {
        targetEvent {
          title
          attendees {
            urnValue
            displayName
          }
          recurrenceRules {
            firstInstanceStartTime {
              ...SuggestionBodyAutopilot_eventTime @relay(mask: false)
            }
            timeZone
            interval {
              interval
              byDay
              bySetPos
              freqType
              count
              untilTime {
                ...SuggestionBodyAutopilot_eventTime @relay(mask: false)
              }
            }
          }
          startTime {
            ...SuggestionBodyAutopilot_eventTime @relay(mask: false)
          }
          endTime {
            ...SuggestionBodyAutopilot_eventTime @relay(mask: false)
          }
        }
      }
    }
  `,
};

export const refetchQuery = graphql`
  query SuggestionBodyAutopilotQuery($orgRelayId: ID!, $calendarIds: [String]!) {
    org: node(id: $orgRelayId) {
      ... on Org {
        ...SuggestionBodyAutopilot_org @arguments(calendarIds: $calendarIds)
      }
    }
  }
`;
